export const ROOT = '/admin'
export const TEAM = `${ROOT}/team`
export const GAMES = `${ROOT}/games`
export const GAMEFORM_NEW = `${ROOT}/game`
export const GAMEFORM_EDIT = `${ROOT}/game/:id`
export const HOME = GAMES



// WEBPACK FOOTER //
// ./src/components/Admin/routes.js